module.exports = __webpack_public_path__ + "img/bomb.9b82d6ff.svg";